import { Component, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateSparkCampaign } from '../../service/create-spark-campaign/create-spark-campaign';
import { AdName } from './atoms/ad-name/ad-name';
import { AdDetails } from './atoms/ad-details/ad-details';
import { AdTracking } from './atoms/ad-tracking/ad-tracking';
import { TiktokSparkAdsService } from '../../../../../../services/tiktok-spark-ads/tiktok-spark-ads.service';

@Component({
  selector: 'app-create-ad',
  imports: [AdName, AdDetails, AdTracking],
  templateUrl: './create-ad.html',
  styleUrl: './create-ad.css',
})
export class CreateAd implements OnInit {

  briefId = signal<string | undefined>(undefined);
  campaignId = signal<string | undefined>(undefined);
  adGroupId = signal<string | undefined>(undefined);

  ad_creation_error = signal<string | undefined>(undefined);

  /** Services */
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);
  public createSparkCampaignService = inject(CreateSparkCampaign);
  private tiktokSparkAdsService = inject(TiktokSparkAdsService);
  /** Services - END */


  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const campaignId = params['campaignId'];
      const adGroupId = params['adGroupId'];
      this.campaignId.set(campaignId);
      this.adGroupId.set(adGroupId);
      console.log('CreateAd - campaignId: ', campaignId);
      console.log('CreateAd - adGroupId: ', adGroupId);

      if (this.createSparkCampaignService.currentSparkAdGroup() && this.createSparkCampaignService.currentSparkAdGroup()!.id === adGroupId) {
        this.getAssociatedAdGroup(adGroupId);
      } else {

      }

      if (!this.createSparkCampaignService.adName()) {
        this.createSparkCampaignService.adName.set(this.buildDefaultAdName());
      }
    })
  }

  private buildDefaultAdName(): string {
    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `Ad Name - ${date} ${time}`;
  }

  getAssociatedAdGroup(adGroupId: string) {
    console.log('getAssociatedAdGroup() ---> ');
  }

  checkAd() {
    console.log('checkAd() ---> ');

    let ad_values: any = {
      ad_name: this.createSparkCampaignService.adName(),
      ad_format: this.createSparkCampaignService.ad_format(),
      identity_type: this.createSparkCampaignService.identity_type(),
      ad_text: this.createSparkCampaignService.ad_text(),
    }
    if (this.createSparkCampaignService.call_to_action()) {
      ad_values.call_to_action = this.createSparkCampaignService.call_to_action();
    }
    if (this.createSparkCampaignService.landing_page_url()) {
      ad_values.landing_page_url = this.createSparkCampaignService.landing_page_url();
    }
    if (this.createSparkCampaignService.enable_disclaimer()) {
      ad_values.disclaimer_type = this.createSparkCampaignService.disclaimer_type();
      ad_values.disclaimer_text = this.createSparkCampaignService.disclaimer_text();
    }
    if (this.createSparkCampaignService.impression_tracking_url()) {
      ad_values.impression_tracking_url = this.createSparkCampaignService.impression_tracking_url();
    }
    if (this.createSparkCampaignService.click_tracking_url()) {
      ad_values.click_tracking_url = this.createSparkCampaignService.click_tracking_url();
    }


    let shout_office_use: any = {
      video_id: this.createSparkCampaignService.selectedCreative()!.video_info.video_id,
      advertiser_id: this.createSparkCampaignService.currentSparkCampaign()?.advertiserId,
      adgroup_id: this.createSparkCampaignService.currentSparkAdGroup()?.tiktokAdGroupId,
    }
    console.log('ad_values: ', ad_values);
    console.log('shout_office_use: ', shout_office_use);

    let newAd: { ad_values: any, shout_office_use: any } = {
      ad_values: ad_values,
      shout_office_use: shout_office_use,
    }
    console.log('newAd: ', newAd);

    this.tiktokSparkAdsService.createSparkAd(newAd).subscribe({
      next: (ad: any) => {
        console.log('createSparkAd() ---> ad: ', ad);
        if (ad.code !== 0) {
          this.ad_creation_error.set(ad.message);
        }
      },
      error: (err) => {
        console.error('createSparkAd() ---> error: ', err);
        this.ad_creation_error.set(err.message);
      },
    });
  }

  updateSettingsRetry() {
    this.ad_creation_error.set(undefined);
  }

  backToBriefs() {
    console.log('backToBriefs() ---> ');
    const briefId = this.briefId();
    if (globalThis.history.length > 1) {
      this.location.back();
    } else if (briefId) {
      void this.router.navigate(['/manage-brief', briefId]);
    }
  }
}
